import moment from "moment"

require("twix");

const TimeSettings = {
    EntriesPerSingleDate: function (wmsTimeString) {
        const datetimeEntries = wmsTimeString.split(",");
        const dates = datetimeEntries.map(datetime => datetime.split("T")[0]);
        const datesSet = Array.from(new Set(dates));
        let timeEntriesPerDate = datesSet.map(date => {
            return {"date": date, "values": datetimeEntries.filter(entry => entry.startsWith(date))}
        });
        return timeEntriesPerDate.reverse()
    },
    MonthlyValues: function (wmsTimeString) {
        let monthlyValues = [];
        const dateArray = wmsTimeString.split("/");
        let itr = moment.twix(new Date(dateArray[0]), new Date(dateArray[1])).iterate("month");

        while (itr.hasNext()) {
            let date = itr.next().format("YYYY-MM");
            monthlyValues.push({"date": date, "values": date})
        }
        return monthlyValues.reverse()
    },
    YearlyValues: function (wmsTimeString) {
        let yearlyValues = [];
        const dateArray = wmsTimeString.split("/");
        const startYear = new Date(dateArray[0]).getFullYear();
        const endYear = new Date(dateArray[1]).getFullYear();
        for (var i = startYear; i <= endYear; i++) {
            yearlyValues.push({"date": `${i}`, "values": `${i}`});
        }

        return yearlyValues.reverse()
    }
};

export default TimeSettings